import { handleApiError } from "@/lib/handleError";
import { EmissionEquivalentRow } from "../types/emissions.types";

export const fetchEmissionsComparison = async (
  column: string,
  filter: string,
  emissions: number[]
): Promise<EmissionEquivalentRow[] | null> => {

  const queryString = `column=${encodeURIComponent(column)}&filter=${encodeURIComponent(filter)}&emissions=${emissions.join(",")}`;
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/emissions-comparison?${queryString}`);

  const errorResult = await handleApiError(res);
  if (errorResult === null) return null;

  return res.json();
};
